import { once } from 'ramda';

export const removeViewerPlaceholder = once(() => {
    const viewerPlaceholder: HTMLElement | null = document.querySelector('#viewerPlaceholder');
    if (viewerPlaceholder) {
        requestAnimationFrame(() => {
            viewerPlaceholder.style.display = 'none';
        });
    }
});
